<template>
  <div style="height:calc(100vh - 83px)">
     <div style="height:60px;" class="comm-settings-top-nav">
      <div class="justify-content-start" style="width:100%;">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb comm-settings-top-nav m-0">
            <li class="comm-icon-rtl">
              <back-button v-on:click.native="changeToSelectedBinComponent('show-bins')" style="position: relative;"></back-button>
            </li>
            <!-- <li class="breadcrumb-item"><a v-on:click="changeToSelectedBinComponent('show-b""ins')">Bins</a></li> -->
            <li class="breadcrumb-item active-text-nav-bar mt-1" aria-current="page">{{selectedBinID}}</li>
            </ol>
        </nav>
      </div>
    </div>
      <nav class="navbar navbar-expand-lg p-0">
        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div class="navbar-nav w-100 top-nav-bar">
                <a class="nav-item nav-link" @click="currentDiv= 'BinBasicInfo'" :class="(currentDiv == 'BinBasicInfo')?'activeNav':'inactiveNav'">{{$t('Basic Info')}}</a>
                <a class="nav-item nav-link" v-show="!['proxy','archive'].includes(selectedBinInfo.bin_type)"
                @click="currentDiv ='BinWatchFolder'"  :class="(currentDiv == 'BinWatchFolder')?'activeNav':'inactiveNav'">{{$t('Watch folder')}}</a>
                <a class="nav-item nav-link" v-show="['asset'].includes(selectedBinInfo.bin_type)"
                  @click="currentDiv ='AdvancedOptions'"  :class="(currentDiv == 'AdvancedOptions')?'activeNav':'inactiveNav'">{{$t('Advanced')}}</a>
            </div>
        </div>
      </nav>
    <template v-if="currentDiv == 'BinBasicInfo'">
    <div id="BinBasicInfo" class="tabcontent" style="height: 100%;">
     <div style="height:80%;overflow: auto;">
        <table class="table bins-basic-info-table" style="background:transparent;overflow:auto;">
      <thead style="color:#eee">
        <tr>
          <th scope="col" style="width:20%"></th>
          <th scope="col" style="width:80%;"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="key-div">Bin ID *</td>
          <td class="value-div d-inline-flex float-left m-0">
            <div class="w-100">
              <div class="d-inline-block">
                <span v-show="!isBinEditing('binId')">{{selectedBinInfo.bin_id}}</span>
                <div class="config-desc">
                    {{$t('Is unique ID for the BIN and its non editable once it created')}}.
                  </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="key-div">{{$t('Bin Name')}} *</td>
          <td class="value-div d-inline-flex float-left m-0">
            <div class="w-100">
              <div class="d-inline-flex">
                <span v-if="!isBinEditing('binname') && selectedBinInfo.bin_name != undefined && selectedBinInfo.bin_name.length">{{
                      selectedBinInfo.bin_name
                    }}</span>
                <span v-else-if="!isBinEditing('binname')" class="empty-field-text-styles">NONE</span>
                <edit-icon @click.native="editBasicBinInfoField('binname')" v-show="!isBinEditing('binname')" class="editIcon"></edit-icon>
              </div>
              <input type="text" v-model='editedBinInfo.bin_name' v-show="isBinEditing('binname')" placeholder="Enter bin name" class="rounded text-light comm-input-field-style align-input-field"/>
            </div>
            <div v-show="isBinEditing('binname')">
              <div class="d-flex">
                <save-icon @click.native="saveBasicBinInfoField('bin_name')"></save-icon>
                <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="key-div">{{$t('Bin Type')}} *</td>
          <td class="value-div d-inline-flex float-left m-0">
            <div class="w-100">
              <div class="d-inline-flex">
                <span v-if="!isBinEditing('bintype') && selectedBinInfo.bin_type != undefined && selectedBinInfo.bin_type.length">{{
                      selectedBinInfo.bin_type
                    }}</span>
                <span v-else-if="!isBinEditing('bintype')" class="empty-field-text-styles">NONE</span>
                <!-- <edit-icon @click.native="editBasicBinInfoField('bintype')" v-show="!isBinEditing('bintype')" class="editIcon"></edit-icon> -->
              </div>
              <select v-show="isBinEditing('bintype')" placeholder="Select bin type" class="rounded text-light comm-input-field-style align-input-field" style="height:26px;">
                <option value="archive">Archive</option>
                <option value="asset">Asset</option>
              </select>
            </div>
            <!-- <div v-show="isBinEditing('bintype')">
              <div class="d-flex">
                <save-icon @click.native="saveBasicBinInfoField('bintype')"></save-icon>
                <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
              </div>
            </div> -->
          </td>
        </tr>
        <tr>
          <td class="key-div">{{$t('Status')}}</td>
          <td class="value-div">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="customSwitch1" @change="saveBasicBinInfoField('status',false,{},$event.target.checked)"
            :checked="selectedBinInfo.status === 'active'"/>
              <label class="custom-control-label" for="customSwitch1">
                <span v-if="selectedBinInfo.status === 'active'" class="text-success"
                  >Active</span>
                <span v-else class="text-danger">Inactive</span></label>
            </div>
          </td>
        </tr>
        <tr v-if="selectedBinInfo.bin_type == 'deployment'">
          <td class="key-div">{{$t('Export Datewise')}}</td>
          <td class="value-div">
            <div class="custom-control custom-switch">
              <input type="checkbox" @change="saveBasicBinInfoField('datewise_export',false,{},$event.target.checked)"
              class="custom-control-input" id="customSwitch3" :checked="selectedBinInfo.datewise_export == true">
              <label class="custom-control-label" for="customSwitch3">
                <span
                  v-if="selectedBinInfo.datewise_export == true"
                  class="text-success"
                  >{{$t('Enabled')}}
                </span>
                <span v-else class="text-danger">{{$t('Disabled')}}</span>
              </label>
            </div>
          </td>
        </tr>
        <template v-if="selectedBinInfo.bin_type == 'proxy'">
          <tr>
            <td class="key-div">{{$t('Preview Path')}}</td>
            <td class="value-div d-inline-flex float-left m-0">
              <div class="w-100">
                <div class="d-inline-flex">
                  <span v-if="!isBinEditing('previewpath') && selectedBinInfo.proxy_options.preview_url != undefined && selectedBinInfo.proxy_options.preview_url.length">{{
                      selectedBinInfo.proxy_options.preview_url
                    }}</span>
                  <span v-else-if="!isBinEditing('previewpath')" class="empty-field-text-styles">NONE</span>
                  <edit-icon @click.native="editBasicBinInfoField('previewpath')" v-show="!isBinEditing('previewpath')" class="editIcon"></edit-icon>
                </div>
                <input type="text" v-model='proxyInfo.preview_url' v-show="isBinEditing('previewpath')" placeholder="asset,archive" class="rounded text-light comm-input-field-style align-input-field"/>
              </div>
              <div v-show="isBinEditing('previewpath')">
                <div class="d-flex">
                  <save-icon @click.native="saveBasicBinInfoField('preview_url')"></save-icon>
                  <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                </div>
              </div>
            </td>
          </tr>
          <!-- <tr>
            <td class="key-div">{{$t('Supported Bin Types')}}</td>
            <td class="value-div d-inline-flex float-left m-0">
              <div class="w-100">
                <div class="d-inline-flex">
                  <span v-if="!isBinEditing('supportedBinTypes') && getSupportedProxybinTypes() != undefined && getSupportedProxybinTypes().length">{{
                      getSupportedProxybinTypes()
                    }}</span>
                  <span v-else-if="!isBinEditing('supportedBinTypes')" class="empty-field-text-styles">NONE</span>
                  <edit-icon @click.native="editBasicBinInfoField('supportedBinTypes')" v-show="!isBinEditing('supportedBinTypes')" class="editIcon"></edit-icon>
                </div>
                <input type="text" v-model='proxyInfo.supported_bin_types' placeholder="Enter supported bin types" v-show="isBinEditing('supportedBinTypes')" class="rounded text-light comm-input-field-style align-input-field"/>
              </div>
              <div v-show="isBinEditing('supportedBinTypes')">
                <div class="d-flex">
                  <save-icon @click.native="saveBasicBinInfoField('supported_bin_types')"></save-icon>
                  <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                </div>
              </div>
            </td>
          </tr> -->
        </template>
      </tbody>
        </table>
        
        <div v-for="(item , index) in nonPrimaryProtocolList " v-bind:key="index">
          <template v-if="index == 0">
            <div class="pb-2 m-4">
              <div  style="display: inline-flex; width: 100%;">
                <button class="btn text-white p-0 pl-2" @click="showCredentialSection = !showCredentialSection" style="position: relative;
                bottom: 11px;inset-inline-end:1%">
                  <svg v-show="showCredentialSection" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                  </svg>
                  <svg v-show="!showCredentialSection" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </button>
                <h6 class="m-0 text-left">{{$t('Primary Credentials')}}</h6>
              </div>
              <div v-show="showCredentialSection">
                <binCredentialInfoTag ref="protocolType0" :protocolType="item" :credentialsInfo="getNonPrimaryProtocolCredentials(item,true)"
                :binId="selectedBinInfo.bin_id" @validateNewProtocol="validateProtocolStrategy" @update-protocol-strategy="updateProtocol" :strategyIndex=0></binCredentialInfoTag>
              </div> 
            </div>
          </template>
        </div>
        <!-- <template v-if="index != 0 && index == 1"> -->
          <div class="pb-2 m-4" v-show="nonPrimaryProtocolList.length > 0">
            <div  style="display: inline-flex; width: 100%;">
              <button class="btn text-white p-0 pl-2" @click="showSecondarySection = !showSecondarySection" style="position: relative;
                bottom: 11px;inset-inline-end:1%">
                <svg v-show="showSecondarySection" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                <svg v-show="!showSecondarySection" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                </svg>
              </button>
              <h6  class="m-0 text-left">{{$t('Secondary Credentials')}}</h6>
            </div>
            <div v-show="showSecondarySection">
                <binCredentialInfoTag ref="protocolType1" :protocolType="getSecProtocolType" :credentialsInfo="getNonPrimaryProtocolCredentials('',false)"
                 :binId="selectedBinInfo.bin_id" @validateNewProtocol="validateProtocolStrategy"  @update-protocol-strategy="updateProtocol" :strategyIndex="1"></binCredentialInfoTag>
            </div>
          </div>
        <!-- </template> -->
      </div>
    </div>
    </template>
    <template v-if="currentDiv == 'BinWatchFolder'">
    <div id="BinWatchFolder" class="tabcontent" >
      <table class="table bins-basic-info-table pl-4" style="background:transparent;overflow:auto;height:85%;">
    <thead style="color: #eee">
      <tr>
        <th scope="col" style="width: 20%"></th>
        <th scope="col" style="width: 80%"></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="key-div">{{$t('Watch Folder Status')}}</td>
        <td class="value-div"><div class="custom-control custom-switch">
          <input type="checkbox" @change="onWatchStatusChange()" v-model="watchFolderStatus"
           class="custom-control-input" id="customSwitch2" :checked="watchFolderStatus === 'active'">
          <label class="custom-control-label" for="customSwitch2">
            <span
              v-if="watchFolderStatus"
              class="text-success"
              >Active</span
            >
            <span v-else class="text-danger">{{$t('Inactive')}}</span></label
          >
        </div></td>
      </tr>
      <tr v-show="watchFolderStatus">
        <td class="key-div">{{$t('Watch Folder')}}</td>
        <td class="value-div d-inline-block float-left m-0">
          <div class='d-inline-flex'>
            <div class="w-100">
              <div class="d-inline-flex">
                <span v-show="!isBinEditing('watchfolder')">{{watchFolderDetails.watch_path}}</span>
                <!-- <div class="config-desc" style="font-size:12px;position: relative;
          top: 5px;">(non editable)</div> -->
                <edit-icon @click.native="editBasicBinInfoField('watchfolder')" v-show="!isBinEditing('watchfolder')" class="editIcon"></edit-icon>
              </div>
              <input type="text" v-model="postWatchFolderData.watch_path" :placeholder="$t('Enter watch folder name')" ref="watchFolderNameEdit" v-show="isBinEditing('watchfolder')" class="rounded text-light comm-input-field-style align-input-field"/>
            </div>
            <div v-show="isBinEditing('watchfolder')">
              <div class="d-flex">
                <!-- <browse-icon @click.native="browseForFolder = 'watch_path';isFolderBrowseModalVisible=true"></browse-icon> -->
                <save-icon @click.native="saveBasicBinInfoField('watch_path',true)"></save-icon>
                <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
              </div>
            </div>
          </div>
          <div class="config-desc">
            {{$t('Folder name from which files are ingested to FUSION application')}}.
          </div>
        </td>
      </tr>
      <tr v-show="watchFolderStatus">
        <td class="key-div">Out Folder</td>
        <td class="value-div d-inline-block float-left m-0">
          <div class='d-inline-flex'>
          <div class="w-100">
            <div class="d-inline-flex">
                <span v-show="!isBinEditing('outFolder')">{{watchFolderDetails.pass_path}}</span>
                <!-- <div class="config-desc" style="font-size:12px;position: relative;top: 5px;">
                  (non editable)
                </div> -->
              <edit-icon @click.native="editBasicBinInfoField('outFolder')" v-show="!isBinEditing('outFolder')" class="editIcon"></edit-icon>
            </div>
            <input type="text" v-model="postWatchFolderData.pass_path" :placeholder="$t('Enter out folder name')" ref="outFolderNameEdit" v-show="isBinEditing('outFolder')" class="rounded text-light comm-input-field-style align-input-field"/>
          </div>
          <div v-show="isBinEditing('outFolder')">
            <div class="d-flex">
              <!-- <browse-icon @click.native="browseForFolder = 'pass_path';isFolderBrowseModalVisible=true"></browse-icon> -->
              <save-icon @click.native="saveBasicBinInfoField('pass_path',true)"></save-icon>
              <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
            </div>
          </div>
          </div>
          <div class="config-desc">
            {{$t('Files from watch folder moved to Out folder on successful ingest')}}.
          </div>
          <div style="padding: 8px 0px 0px 13px;">
                <input type="checkbox" :checked="watchFolderDetails.create_pass_path_datewise === true" @change="saveBasicBinInfoField('create_pass_path_datewise',true,{},$event.target.checked)"
                 class="bg-transparent border rounded text-light bigger-checkboxes"/>
                <label style="position: relative;bottom: 10px;inset-inline-start:8px !important">{{$t('Datewise folder structure')}}</label>
                <Multiselect
                      v-show="watchFolderDetails.create_pass_path_datewise === true"
                      :value="watchPassPathDateStruct"
                      :options="watchPassPathDateStructOptions"
                      :searchable="false"
                      :close-on-select="true"
                      :allow-empty="false"
                      deselectLabel=""
                      selectLabel=""
                      selectedLabel=""
                      track_by="format"
                      label="label"
                      @select="onPassPathDateSturctChange($event)"
                      :placeholder="$t('Watch intervals')"
                      style="width: 50% !important;">
                      <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                      <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                      </div>
                      <span slot="noResult">No results.</span>
                </Multiselect>
                <span v-show="watchFolderDetails.create_pass_path_datewise == true"
                  class="config-desc" style="padding: 0px !important;margin: 0px;">{{$t('Datewise folder format to ingest files in to FUSION application')}}.
                </span>
          </div>
          <div style="padding: 8px 0px 0px 13px;">
            <input type="checkbox" :checked="watchFolderDetails.keep_watch_path_structure === true"
             @change="saveBasicBinInfoField('keep_watch_path_structure',true,{},$event.target.checked)"
             class="bg-transparent border rounded text-light bigger-checkboxes"/>
            <label style="position: relative;bottom: 10px;inset-inline-start:8px !important">{{$t('Keep watch path structure')}}</label>
          </div>
        </td>
      </tr>
      <tr v-show="watchFolderStatus">
        <td class="key-div">{{$t('Error Folder')}}</td>
        <td class="value-div d-inline-block float-left m-0">
          <div class="d-inline-flex">
          <div class="w-100">
            <div class="d-inline-flex">
              <span v-show="!isBinEditing('errorfolder')" >{{watchFolderDetails.error_path}}</span>
              <div class="config-desc" style="font-size:12px;position: relative;
        top: 5px;">(non editable)</div>
              <!-- <edit-icon @click.native="editBasicBinInfoField('errorfolder')" v-show="!isBinEditing('errorfolder')" class="editIcon"></edit-icon> -->
            </div>
            <input type="text" v-model="postWatchFolderData.error_path" v-show="isBinEditing('errorfolder')" class="rounded text-light comm-input-field-style align-input-field"/>
          </div>
          <div v-show="isBinEditing('errorfolder')">
            <div class="d-flex">
              <browse-icon @click.native="browseForFolder = 'error_path';isFolderBrowseModalVisible=true"></browse-icon>
              <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
            </div>
          </div>
          </div>
          <div class="config-desc">
            {{$t('Files from watch folder moved to Error folder whenever if files extensions are not allowed')}}.  
          </div>
        </td>
      </tr>
      <tr v-show="watchFolderStatus">
        <td class="key-div">{{$t('Watch Intervel')}}</td>
        <td class="value-div d-inline-block m-0" style="float:inline-start;margin-inline-start:10px">
          <div class="d-inline-flex" style="width:78%">
          <div class="w-100" style="display:inherit">
            <div style="display:inherit;">
              <span v-show="!isBinEditing('interval')">{{watchFolderDetails.watch_interval}}</span>
              <edit-icon @click.native="editBasicBinInfoField('interval')" v-show="!isBinEditing('interval')" class="editIcon"></edit-icon>
            </div>
             <Multiselect
             v-show="isBinEditing('interval')"
             :value="watchFolderDetails.watch_interval"
            :options="watchIntervals"
            :searchable="false"
            :close-on-select="true"
            :allow-empty="false"
            @select="onChange($event)"
            deselectLabel=""
            selectLabel=""
            selectedLabel=""
            placeholder="Watch intervals">
            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
            <span style="margin-inline-start:12px;">{{ scope.option }}</span>
            </div>
            <span slot="noResult">No results.</span>
          </Multiselect>
          </div>
          <div v-show="isBinEditing('interval')">
            <div class="d-flex" style="position: relative;
        top: 7px;">
              <save-icon @click.native="saveBasicBinInfoField('watch_interval')"></save-icon>
              <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
            </div>
          </div>
          </div>
          <div class="config-desc">
            {{$t('Wait time (in Sec) to start next poling iteration on watch folder')}}. 
          </div>
        </td>
      </tr>
      <tr v-show="watchFolderStatus">
        <td class="key-div">Detect file types</td>
        <td class="value-div m-0 d-inline-flex w-100 pb-0">
            <div class="d-inline-flex w-25">
              <input type="radio"  value="include_list" v-model="fileTypesStrategy" @change="updateFileType()" class="bg-transparent border rounded text-light bigger-checkboxes" name="file type"/>
              <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Include list')}}</label>
            </div>
            <div class="d-inline-flex w-25">
              <input type="radio"  value="exclude_list" v-model="fileTypesStrategy"  @change="updateFileType()" class="bg-transparent border rounded text-light bigger-checkboxes" name="file type"/>
              <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Exclude list')}}</label>
            </div>
            <div class="d-inline-flex w-25">
              <input type="radio"  value="regex_pattern" v-model="fileTypesStrategy"  @change="updateFileType()" class="bg-transparent border rounded text-light bigger-checkboxes" name="file type"/>
              <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Regexp')}}</label>
            </div>
        </td>
      </tr>
      <tr v-show="watchFolderStatus">
        <td class="key-div"></td>
        <td class="value-div d-inline-block ml-0 pt-0 pb-0" style="width: 62%;float:inline-start">
          <div class="d-inline-flex w-100">
          <div class="w-100">
            <div class="d-inline-flex">
              <span v-show="!isBinEditing('file_type')">{{supportedFileList}}</span>
              <edit-icon @click.native="editBasicBinInfoField('file_type')" v-show="!isBinEditing('file_type')" class="editIcon"></edit-icon>
            </div>
            <input type="text" id="supported_values" v-show="isBinEditing('file_type')" v-model="supportedFileList" class="rounded text-light comm-input-field-style align-input-field" placeholder="mp4,mpeg,mxf,mov"/>
          </div>
          <div v-show="isBinEditing('file_type')">
            <div class="d-flex">
              <save-icon @click.native="updateFileType()"></save-icon>
              <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
            </div>
          </div>
          </div>
          <div class="config-desc">
            {{$t('Allowed file extensions to ingest in to FUSION application')}}.
          </div>
        </td>
      </tr>
      <tr v-show="watchFolderStatus">
        <td class="key-div">Unique String</td>
        <td class="value-div m-0 pb-0">
            <input type="checkbox" v-model="appendUniqueString" @click="toggleUniqueStringUpdated()" class="bg-transparent border rounded text-light bigger-checkboxes"
             :checked="appendUniqueString"/>
            <label style="position: relative;bottom: 9px;inset-inline-start:5px">{{$t('Attach unique string to make each file unique')}}</label>
        </td>
      </tr>
      <tr v-if="appendUniqueString && watchFolderStatus" style="position: relative;bottom: 15px;">
        <td class="key-div"></td>
        <td class="value-div m-0 d-inline-block w-100">
          <div class="w-100" style="display:grid">
          <div class="d-inline-flex w-50">
            <input type="radio" :checked="uniqueStringStrategySequence == 'sequence'" @change="toggleUniqueString(true)"  class="bg-transparent border rounded text-light bigger-checkboxes" name="Unique String"/>
            <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Sequence number')}}</label>
          </div>
          <div class="d-inline-flex w-50">
            <input type="radio" :checked="uniqueStringStrategySequence == 'timestamp'" @change="toggleUniqueString(false)"  class="bg-transparent border rounded text-light bigger-checkboxes" name="Unique String"/>
            <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Date and timestamp')}}</label>
          </div>
          </div>
          <div class="config-desc">
           {{$t('Append string to make filename unique across the system')}}.
          </div>
        </td>
      </tr>
      <tr v-show="watchFolderStatus">
        <td class="key-div">{{$t('Last watched time')}}</td>
        <td class="value-div d-flex m-0">
          <span>{{getDateAndTimeInConfiguredFormat(watchFolderDetails.last_watched_datetime)}}</span>
        </td>
      </tr>
    </tbody>
      </table>
    </div>
    </template>
    <template v-if="currentDiv == 'AdvancedOptions'">
      <div id="AdvancedOptions" class="tabcontent" style="overflow:auto;">
        <table class="table bins-basic-info-table pl-4" style="background:transparent;overflow:auto;height:93%;display:block;width:100%">
          <thead style="color: #eee">
            <tr>
              <th scope="col" style="width: 20%"></th>
              <th scope="col" style="width: 80%"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="key-div">{{$t('Archive Options')}}</td>
              <td class="value-div d-block m-0 w-100">
                <div>
                  <input type="checkbox" v-model="advancedOptions.enable_archive_trash"
                    @change="onArchiveTrashStatusChange()" class="bg-transparent border rounded text-light bigger-checkboxes"/>
                  <label style="position: relative;bottom: 10px;inset-inline-start:8px !important">{{$t('Move to Archive Trash')}}</label>
                </div>
                <span class="config-desc">{{$t('Move files to trash folder after archive')}}. </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Utils from "../../components.utils.js";
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import BinCredentialInfo from "../bins/BinCredentialInfo";
import BrowseIcon from "../core/InlineBrowseField.vue";
import BackButton from "../core/backButton.vue";
import Multiselect from 'vue-multiselect';
import {NotifierConstants} from "../../components.constants.js";


export default {
  name:'MultiSelect',
  data() {
    return {
      advancedOptions:{
        enable_archive_trash: false,
      },
      watchFolderDetails:{
        watch_interval:10,
        create_pass_path_datewise:false,
      },
      watchPassPathDateStruct:{label:"Jan-17/01-01-2018", format:"%b-%y@%d-%m-%Y"},
      watchPassPathDateStructOptions:[
        {label:"Jan-18/01-01-2018", format:"%b-%y@%d-%m-%Y"},
        {label:"Jan-18/01-01-18", format:"%b-%y@%d-%m-%y"},
        {label:"2018/Jan/1-01-2018", format:"%Y@%b@%d-%m-%Y"},
        {label:"01-01-2018", format:"%d-%m-%Y"}
      ],
      watchIntervals:[1,5,10,30,60,300],
      browseForFolder:"",
      isFolderBrowseModalVisible: false,
      currentDiv:'BinBasicInfo',
      showCredentialSection:true,
      selectedPrimaryProtocolType:"file",
      showSecondarySection:true,
      selectedSecondaryProtocolType:"file",
      supportedFileList:"Empty",
      fileTypesStrategy:"include_list",
      appendUniqueString:false,
      uniqueStringStrategySequence:"sequence",
      selectedBinInfo: {},
      postWatchFolderData:{},
      editedBinInfo:{
        datewise_export:false,
      },
      proxyInfo:{},
      editingBinKey: null,
      validPassword: true,
      loginStatus: false,
      secondaryValidBackupIp:true,
      validBackupIp:true,
      secondaryValidIp: true,
      validIp:true,
      validSecPassword:true,
      primaryProtocol:"",
      nonPrimaryProtocolList:[],
      passwordFieldType: "password",
      secondaryPasswordFieldType: "password",
      passwordRegex: new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/),
      ipAddressRegex: new RegExp(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/),
    };
  },
  props: ["selectedBinID"],
   components: {
    "browse-icon":BrowseIcon,
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
    "cancel-icon": CancelIcon,
    "binCredentialInfoTag":BinCredentialInfo,
    "back-button":BackButton,
    "Multiselect":Multiselect
  },
  computed:{
    getSecProtocolType(){
      if(this.selectedBinInfo.protocol_strategy != undefined && this.selectedBinInfo.protocol_strategy.length == 1){
        return ""
      }else{
        if(this.selectedBinInfo.protocol_strategy != undefined){
          return this.selectedBinInfo.protocol_strategy[this.selectedBinInfo.protocol_strategy.length - 1]
        }
        return ""
      }
    }
  },
  methods: {
    selectedBinPath(selectedPath) {
      this.postWatchFolderData[this.browseForFolder] = selectedPath.path
      this.saveBasicBinInfoField(this.browseForFolder,true)
      this.isFolderBrowseModalVisible = false
    },
    onChange(event){
      this.postWatchFolderData["watch_interval"] = parseInt(event);
      this.saveBasicBinInfoField("watch_interval",true)
    },
    onPassPathDateSturctChange(event){
      this.postWatchFolderData["pass_path_datewise_format"] = event.format
      this.saveBasicBinInfoField("pass_path_datewise_format",true)
    },
    changeToSelectedBinComponent(compName, payload={}){
      this.$emit("changeToSelectedBinComponent", compName, payload)
    },
    onWatchStatusChange(){
      this.saveBasicBinInfoField("watch_status",true);
    },
    onArchiveTrashStatusChange(){
      this.saveBasicBinInfoField("archive_options");
    },
    isBinEditing(keyName) {
      return keyName === this.editingBinKey;
    },
    getPrimarySecondaryCredentials(){
      let protocols = this.selectedBinInfo["protocol_strategy"];
      if(protocols.length > 0){
        this.selectedPrimaryProtocolType = protocols[0];
        this.primaryProtocol = protocols[0];
      }
    },
    getSupportedProxybinTypes(){
      let supportedBinTypes = this.selectedBinInfo.proxy_options.supported_bin_types
      if(typeof supportedBinTypes == "string"){
        return supportedBinTypes
      }
      return supportedBinTypes.join(",")
    },
    getSupportedFiltypes(){
      this.watchFolderDetails = this.selectedBinInfo["watch_options"]
      if(typeof(this.watchFolderDetails) == "undefined"){
        this.watchFolderDetails ={
          watch_interval:10,
          poll_strategy:{
           include_list:["mp4,mpeg,mxf,mov,avi"],
           strategy:"include_list"
          },
          watch_path:"INBOX",
          error_path:"ERROR",
          pass_path:"ONAIR",
          status: false,
          create_pass_path_datewise:false
        }
      }
      for(let pOp of this.watchPassPathDateStructOptions){
        if(pOp.format == this.watchFolderDetails.pass_path_datewise_format){
          this.watchPassPathDateStruct = pOp
          break;
        }
      }
      this.watchFolderStatus = this.watchFolderDetails.status
      let fileTypeMap = this.watchFolderDetails["poll_strategy"]
      this.fileTypesStrategy = fileTypeMap["strategy"]
      if(typeof(fileTypeMap[this.fileTypesStrategy]) != "undefined"){
        if(this.fileTypesStrategy == 'regex_pattern' ){
          this.supportedFileList = fileTypeMap[this.fileTypesStrategy]
        }else {
          let supportedList = fileTypeMap[this.fileTypesStrategy]
          if(typeof(supportedList) == "undefined"){
            supportedList = ""
          }
          this.supportedFileList = supportedList.join(",")
        }
      }else{
        this.supportedFileList = ""
      }
      if(this.containsKey(this.watchFolderDetails, 'attach_unique_string')){
        this.appendUniqueString = this.watchFolderDetails["attach_unique_string"];
      }
      let uniqueStringInfo = {}
      if(this.containsKey(this.watchFolderDetails, "unique_string")){
        uniqueStringInfo = this.watchFolderDetails["unique_string"]
        this.uniqueStringStrategySequence = uniqueStringInfo["strategy"]
      }
      this.postWatchFolderData = this.watchFolderDetails
    },
    refreshBinInfo(){
      let payload = {};
      if(typeof(this.selectedBinID) != "undefined" || this.selectedBinID != null){
      payload.params = { binId: this.selectedBinID };
      this.getBinInfoFromServer(payload).then((resp) => {
        if(typeof(resp.bin) != "undefined" && Object.keys(resp.bin).length > 0){
            this.selectedBinInfo = resp.bin;
            this.$set(this.selectedBinInfo, "protocol_strategy", resp.bin["protocol_strategy"])
            this.editedBinInfo = this.selectedBinInfo;
            this.proxyInfo = this.selectedBinInfo.proxy_options
            if(this.containsKey(this.selectedBinInfo, 'watch_options')){
              this.getSupportedFiltypes()
            }
            if('archive_options' in this.selectedBinInfo){
              this.advancedOptions = this.selectedBinInfo.archive_options
            }
            this.getNonPrimaryProtocol();
            this.getPrimarySecondaryCredentials();
        }
        else if (!(Utils.isAcceptedStatusCode(resp.statusCode))){
          this.$toast.error(resp.message);
        }
      });
      }
    },
    validPasswordCheck() {
      if (this.passwordRegex.exec(this.password) != null){
        this.validPassword = true;
      } else {
        this.validPassword = false;
      }
    },
    secIpValidationCheck(){
      if (this.ipAddressRegex.exec(this.secIp) != null){
        this.secondaryValidIp = true;
      } else {
        this.secondaryValidIp = false;
      }
    },
    ipAddressValidationCheck(){
      if (this.ipAddressRegex.exec(this.IpAddress) != null){
        this.validIp = true;
      } else {
        this.validIp = false;
      }
    },
    containsKey(obj, key ) {
      if(typeof(obj) == "undefined"){
        return false
      }
      return Object.keys(obj).includes(key);
    },
    validateProtocolStrategy(selectedProto, strategyIndx){
      if(this.selectedBinInfo["protocol_strategy"].includes(selectedProto)){
        alert("Primary and secondary protocols can not be the same. \nPlease try again. ")
        return
      }else{
        let refName = `protocolType${strategyIndx.toString()}`
        if(Array.isArray(this.$refs[refName])){
          this.$refs[refName][0].validatedProtocol()
        }else{
          this.$refs[refName].validatedProtocol()
        }
      }
    },
    updateProtocol(credentials, strategyIndex, newProtocolType){
      if(typeof newProtocolType == "undefined" || (newProtocolType.trim().length <= 0 && strategyIndex == 0)){
        this.cancelBasicBinInfoField()
        return
      }
      if(typeof(this.selectedBinInfo["protocol_strategy"]) != "undefined"){
        let updatedProtocolStrategy = this.selectedBinInfo["protocol_strategy"]
        // if(updatedProtocolStrategy.includes(newProtocolType)){
        //   alert("Primary and Secondary protocol types cann't be same. \nPlease add different credentials. ");
        //   return
        // }
        updatedProtocolStrategy[strategyIndex] = newProtocolType
        let payload = credentials
        if(updatedProtocolStrategy.includes("")){
          updatedProtocolStrategy.splice(updatedProtocolStrategy.indexOf(""),1)
        }
        payload["protocol_strategy"] = updatedProtocolStrategy
        this.saveBasicBinInfoField("protocol",false, payload)
        this.cancelBasicBinInfoField()
        return
      }
      alert("Unable to update the protocol. \nPlease try again. ")
    },
    getPrimaryProtocolCredentials(){
      return this.selectedBinInfo[this.primaryProtocol]
    },
    getselectedBinID(){
      return this.selectedBinID
    },
    getNonPrimaryProtocol(){
      let secondaryList = this.selectedBinInfo.protocol_strategy;
      if(typeof(secondaryList)!="undefined" && secondaryList.length > 0){
        if(secondaryList.length == 1){
          secondaryList.push("")
        }
        this.nonPrimaryProtocolList = secondaryList
        return
      }
      this.nonPrimaryProtocolList = []
    },
    getNonPrimaryProtocolCredentials(key,isPrimary){
      if(!isPrimary){
        if(this.selectedBinInfo.protocol_strategy != undefined && this.selectedBinInfo.protocol_strategy.length == 1){
        return {}
        }else{
          if(this.selectedBinInfo.protocol_strategy != undefined){
                let secProtoValue = this.selectedBinInfo.protocol_strategy[this.selectedBinInfo.protocol_strategy.length - 1]
                return this.selectedBinInfo["protocol_credentials"][secProtoValue]
          }
        }
      }
      return this.selectedBinInfo["protocol_credentials"][key]
    },
    backupIpAddressValidationCheck(){
      if (this.ipAddressRegex.exec(this.BackupIp) != null){
        this.validBackupIp = true;
      } else {
        this.validBackupIp = false;
      }
    },
    validSecPasswordCheck() {
      if (this.passwordRegex.exec(this.secpassword) != null){
        this.validSecPassword = true;
      } else {
        this.validSecPassword = false;
      }
    },
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
    },
    switchPasswordVisibility(){
      this.secondaryPasswordFieldType = this.secondaryPasswordFieldType === "password" ? "text" : "password";
    },
    editBasicBinInfoField(keyName) {
      this.editingBinKey = keyName;
    },
    changePrimaryProtocolType(event){
      this.selectedPrimaryProtocolType = event.target.value;
    },
    saveBasicBinInfoField(field, isWatchFolder=false, postData={}, status){
      let payload ={}
      if(field == 'datewise_export'){
        payload[field] = status
      }else if(field == "bin_name"){
        if(!this.containsKey(this.editedBinInfo, field) ||
           typeof(this.editedBinInfo["bin_name"]) == "undefined" ||
            this.editedBinInfo["bin_name"].trim().length <= 0) {
             alert("Please add valid binname. ")
             return
        }
        payload[field] = this.editedBinInfo[field]
      }else if(field == "status"){
        if(this.editedBinInfo[field] && status){
          payload[field] = "active"
        }else{
          payload[field] = "disabled"
        }
      }else if(field == "protocol"){
        payload = postData
      }else if(field == "preview_url"){
        let proxyOptions = {
          preview_url : this.proxyInfo.preview_url
        }
        payload["proxy_options"] = proxyOptions
      // }else if(field == "supported_bin_types"){
      //   let previewTypes = this.proxyInfo.supported_bin_types
      //   let proxyOptions = {}
      //   if(typeof previewTypes == "string"){
      //     proxyOptions.supported_bin_types = previewTypes.split(",")
      //   }
      //   else{
      //     proxyOptions.supported_bin_types = previewTypes
      //   }
      //   payload["proxy_options"] = proxyOptions
      }else if(isWatchFolder){
        let watchDetails = {}
        if(["poll_strategy", "unique_string"].includes(field)){
          watchDetails[field] = postData
        }else if(field == "watch_status"){
          if(this.watchFolderStatus){
            watchDetails={
              "watch_interval":10,
              "poll_strategy":{
                 "include_list":["mp4,mpeg,mxf,mov,avi"],
                 "strategy":"include_list"
               },
               "unique_string":{
                 "strategy":"sequence"
               },
               "attach_unique_string":false,
               "watch_path":"INBOX",
               "error_path":"ERROR",
               "pass_path":"ONAIR"
              }

              if(this.watchFolderDetails.watch_path){
                watchDetails["watch_path"] = this.watchFolderDetails.watch_path;
              }else{
                this.watchFolderDetails.watch_path = "INBOX";
              }

              if(this.watchFolderDetails.pass_path){
                watchDetails["pass_path"] = this.watchFolderDetails.pass_path;
              }else{
                this.watchFolderDetails.pass_path = "ONAIR";
              }

              
              
          }
          else{
            watchDetails ={
                "watch_path":"INBOX",
                "error_path":"ERROR",
                "pass_path":"ONAIR",
                "attach_unique_string":false
            }

              if(this.watchFolderDetails.watch_path){
                watchDetails["watch_path"] = this.watchFolderDetails.watch_path;
              }else{
                this.watchFolderDetails.watch_path = "INBOX";
              }

              if(this.watchFolderDetails.pass_path){
                watchDetails["pass_path"] = this.watchFolderDetails.pass_path;
              }else{
                this.watchFolderDetails.pass_path = "ONAIR";
              }

          }
          watchDetails["status"] = this.watchFolderStatus
          this.watchFolderDetails = watchDetails
          this.watchFolderStatus = this.watchFolderDetails.status
          if(this.watchFolderStatus){
            watchDetails.poll_strategy.include_list = watchDetails["poll_strategy"]["include_list"][0].split(",")
          }

        }else if(field == "unique_string"){
          watchDetails[field] = payload
        }else if(field == "attach_unique_string"){
          watchDetails[field] = this.appendUniqueString
          watchDetails["unique_string"] = postData
        }else if(field == "create_pass_path_datewise"){
          watchDetails[field] = status
          if(status == true){
            watchDetails["pass_path_datewise_format"] = this.watchPassPathDateStruct.format;
          }
        }else if(field == "keep_watch_path_structure"){
          watchDetails[field] = status
        }else{
          watchDetails[field] = this.postWatchFolderData[field]
        }

        if(field == "watch_path" && this.postWatchFolderData["watch_path"].trim() == ""){
          alert("Empty Watch Folder name")
          this.$refs.watchFolderNameEdit.focus();
          return false;
        }

        if(field == "pass_path" && this.postWatchFolderData["pass_path"].trim() == ""){
          alert("To save Empty Out Folder, please type 'EMPTY' and save")
          this.$refs.outFolderNameEdit.focus();
          return false;
        }

        payload["watch_options"] = watchDetails
        this.postWatchFolderData = watchDetails
      }else if(field == "archive_options"){
        payload[field] = this.advancedOptions
      }
      payload["bin_id"] = this.selectedBinID
      this.cancelBasicBinInfoField()
      this.updateExistingBin(payload).then((data)=>{
        if (Utils.isAcceptedStatusCode(data.statusCode)){
          if(Object.keys(data).includes("message")){
           if (data.message.includes("Failed")){
             this.$toast.warning(data.message);
            }else{
             this.$toast.success(data.message);
             this.refreshBinInfo();
           }
          }
       } else {
          this.$toast.error(data.message);
       }
       //update new value to span
      });
    },
    cancelBasicBinInfoField() {
      this.editingBinKey = null;
    },
    toggleUniqueStringUpdated(){
      let uniqueInfo={}
      this.appendUniqueString = !this.appendUniqueString
      if(this.appendUniqueString){
           uniqueInfo ={
            "strategy" : this.uniqueStringStrategySequence
          }
      }
      this.saveBasicBinInfoField("attach_unique_string", true, uniqueInfo)
    },
    toggleUniqueString(isSequence){
      let uniqueInfo = {}
      this.uniqueStringStrategySequence = isSequence
      if(this.uniqueStringStrategySequence){
        uniqueInfo["strategy"] = "sequence"
      }else{
        uniqueInfo["strategy"] = "timestamp"
      }
      this.saveBasicBinInfoField("unique_string", true, uniqueInfo)
    },
    updateFileType(){
      let fileTypeinfo ={
        "strategy":this.fileTypesStrategy
      }
      if(this.fileTypesStrategy == 'regex_pattern'){
          fileTypeinfo[this.fileTypesStrategy] = "Empty"
        if(this.supportedFileList.trim().length > 0){
          fileTypeinfo[this.fileTypesStrategy] = this.supportedFileList
        }
      }else{
        if(this.supportedFileList.trim().length > 0){
          fileTypeinfo[this.fileTypesStrategy] = this.supportedFileList.split(",")
        }
      }
      this.saveBasicBinInfoField("poll_strategy", true, fileTypeinfo);
    },
    handleBinsNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let bin_info = notification.message
        if (bin_info.bin_id == this.selectedBinInfo.bin_id){
          Object.assign(this.selectedBinInfo, bin_info)   
          //Object.assign(this.postData, bin_info)
        }
      }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[ NotifierConstants.binModifiedNotification],
            callback:this.handleBinsNotification,
            parent: "BinInfo"})
    },
    UnregisterfromWebsocketNotifications(){
      this.removeWSEventListener({
            eventname: NotifierConstants.binModifiedNotification,
            callback:this.handleBinsNotification,
            parent: "BinInfo"})
    },
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("bins", ["getBinInfoFromServer", "updateExistingBin"]),
  },
  // created() {
  //   let payload = {};
  //   payload.params = { binId: this.selectedBinID };
  //   this.getBinInfoFromServer(payload).then((resp) => {
  //     this.selectedBinInfo = resp;
  //   });
  // },
  created() {
    this.registerforWebsocketNotifications()
    this.refreshBinInfo();
  },
  beforeDestroy(){
    this.UnregisterfromWebsocketNotifications()
  }
};
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $button-height:38px;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

    ::v-deep{
    .multiselect{
      width:100%;
      margin: 3px 0px;
    }
    .multiselect__tags-wrap{
        display:block;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
        outline:none;
        box-shadow: none;
    }
    .multiselect__tag-icon{
    color:$text-color;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
    color:$secondary-text-color !important;
    font-size: 20px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect__tags{
        padding: 8px 35px 0 8px !important;
    }

    .multiselect__select{
        width:35px !important;
    }
    
    .multiselect__placeholder {
        // padding-top: 5px !important;
        margin-bottom:0px;
        color:#5d5d5d !important;
    }
    .multiselect{
        color:$text-color !important;
        font-size: $input-field-and-label-font-size !important;
        min-height: 36px;
    }
    .multiselect__single{
            margin: 0!important;
            height: 100%;
            display: flex;
            align-items: center;
    }
    .multiselect__option--selected{
        background:$bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: absolute;
        display: block;
        background: $text-color;
        width: 100% !important;
        max-height: 150px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
        // width:auto !important;
    }

    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
    background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background !important;
        height: auto;
    }

}

h6 {
   width: 100%; 
   text-align: center; 
   line-height: 0.1em;
   margin: 10px 0 20px; 
} 

.comm-input-field-style{
    background: $primary-background!important;
    width: 100% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}

.empty-field-text-styles{
  color:$none-text-color;
}

.align-input-field{
  margin-top:-8px;
}


/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}


h6 span { 
    background:$text-color; 
    padding:0 10px; 
}
.bins-basic-info-table{
  font-size: 15px;
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
      width: 50%;
      font-weight: 500;
      span{
        padding-inline-start:12px;
      }
    }
  }
}

.editIcon {
  margin-inline-start: 9px;
}

.activeclass {
  color: $active-blue;
}

.nav-item{
  color: $dull-text-color !important;
  width:15%;
}
.inactiveNav:hover{
  color:$text-color !important;
}

.activeNav{
    background: $primary-background !important;
    font-size:15px;
    font-weight:500;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: none !important;
    }
  }
}

table.bins-basic-info-table .editIcon {
  visibility: hidden;
}
table.bins-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}

.custom-control-label::before {
  background-color: $primary-background;
}
.btn {
  font-size: 14px !important;
  height: 100%;
}

.border {
  border: $border-color !important;
}


input[type='checkbox']:after{
    line-height: 1.5em;
    content: '';
    display: inline-block;
    width: 22px;
    height: 21px;
    margin-top: 5px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: 0.25em;
    background: $primary-background;
}

input[type='checkbox']:checked:after{
    content: '✔';
    color: $active-blue !important;
    position: absolute;
    font-size: 16px;
    line-height: 1;
    transition: all .2s;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px;
    padding-top:2px;
}

.bigger-checkboxes{
    height: 30px;
    width: 20px;
}

.validationmessage{
  color:$danger-color;
  font-size: 11px;
}

.active{
    background: $primary-background !important;
    color: $text-color !important;
}
.top-nav-bar{
    background: $primary-background;
}

.tabcontent{
    position: absolute;
    width: 100%;
    height: calc(100% - 88px);
    overflow: auto;
}

.navbar{
  background: $primary-background;
}

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
}


input[type="radio"] {
    /* background-color only for content */
    background-color:$primary-background !important;
  }
  
  /* appearance for checked radiobutton */
  input[type="radio"]:checked {
    background-color: $active-blue !important;
    //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: $secondary-border-color !important;

  }

  .breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
  align-items:center;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.custom-switch {
    padding-inline-start: 5%;
}

.config-desc{
  color: $dull-text-color;
}

.config-desc{
    width: 100%;
    text-align: initial;
    margin-inline-start: 11px;
}

</style>